import { IAccountModel } from "./model/IAccountModel";
import { Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class AccountService extends ServiceBase {
    public async getAccounts(
        organizationId: string,
        accountType: "" | "GeneralLedger" | "Supplier" | "Customer" | "Other",
        startRow?: number,
        pageSize?: number,
        freeText?: string
    ): Promise<Result<IAccountModel[]>> {

        let url = "/Organization/" + organizationId + "/Accounts/?";

        let terms: string[] = [];

        if (accountType !== "") {
            terms.push("accountType=" + accountType);
        }

        if (startRow) {
            terms.push("startRow=" + startRow);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJsonPaged<IAccountModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }
    public async getAccountGeneralLedgers(
        organizationId: string, startRow?: number, pageSize?: number, freeText?: string
    ): Promise<Result<IAccountModel[]>> {

        let url = "/Organization/" + organizationId + "/Accounts/GeneralLedgers?";

        let terms: string[] = [];

        if (startRow) {
            terms.push("startRow=" + startRow);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJson<IAccountModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }
    public async getAccountSuppliers(
        organizationId: string, startRow?: number, pageSize?: number, freeText?: string
    ): Promise<Result<IAccountModel[]>> {

        let url = "/Organization/" + organizationId + "/Accounts/Suppliers?";

        let terms: string[] = [];

        if (startRow) {
            terms.push("startRow=" + startRow);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJson<IAccountModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }
    public async getAccountCustomers(
        organizationId: string, startRow?: number, pageSize?: number, freeText?: string
    ): Promise<Result<IAccountModel[]>> {

        let url = "/Organization/" + organizationId + "/Accounts/Customers?";

        let terms: string[] = [];

        if (startRow) {
            terms.push("startRow=" + startRow);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJson<IAccountModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }

}